import { useRef, useState, useLayoutEffect } from "react";
import ReactDOM from "react-dom";

const Portal = ({ children, show, targetRef }) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const containerRef = useRef(null);

  useLayoutEffect(() => {
    if (show && targetRef.current && containerRef.current) {
      const rect = targetRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  }, [show, targetRef, children]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div
      ref={containerRef}
      style={{
        position: "absolute",
        top: position.top,
        left: position.left,
        zIndex: 9999,
      }}
    >
      {children}
    </div>,
    document.body
  );
};

export default Portal;
